import { Outlet, createRootRoute, useLocation } from '@tanstack/react-router';
import { CommandPalette } from '@/components/CommandPalette';
import { CommandPaletteProvider } from '@/lib/useCommandPalette';
import { AuthGuard } from '@/components/AuthGuard';

// Shell-less routes: login + the Phase 0 health diagnostic. No rail, no chrome.
const BARE_ROUTES = new Set(['/login', '/health']);

// The user menu lives on the AppRail brand mark (UserMenuBrand) — every
// workspace that mounts AppRail gets it for free. Routes without a rail
// (/login, /health) intentionally render no user controls — and no
// command palette: mounting it there would fire its membership/search queries
// (incl. the session→bearer exchange via useMeQuery) on the unauthenticated
// login + diagnostic screens.
function RootLayout() {
  const { pathname } = useLocation();
  const bare = BARE_ROUTES.has(pathname);
  return (
    <AuthGuard>
      <CommandPaletteProvider>
        <div className="min-h-full bg-bg text-ink">
          <Outlet />
        </div>
        {!bare && <CommandPalette />}
      </CommandPaletteProvider>
    </AuthGuard>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
